import { writeText } from 'clipboard-polyfill'
import React from 'react'
import TextWithTooltipOnClick from 'src/components/TextWithTooltipOnClick/TextWithTooltipOnClick'
import Trns from 'src/localization/Trns'

interface CopyTextLinkProps {
  className?: string
  copyValue: string
  copyText: React.ReactElement
  onClick?: () => void
}

const CopyTextLink: React.FC<CopyTextLinkProps> = (
  props,
): React.ReactElement => {
  const onCopyTextLinkClick = (): void => {
    writeText(props.copyValue)
    if (props.onClick) {
      props.onClick()
    }
  }

  return (
    <TextWithTooltipOnClick
      className={props.className}
      onClick={onCopyTextLinkClick}
      text={props.copyText}
      tooltipBody={<Trns source={'Copied!'} />}
    />
  )
}

export default CopyTextLink
